import {
  GET_PRODUCT_DETAIL_LIST_RESPONSE,
  GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_RESPONSE,
  ADD_PRODUCT_DETAIL_RESPONSE,
  UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE,
  UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_RESPONSE,
  DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE,
  GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
  UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
  DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
  SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_RESPONSE,
  SET_PRODUCT_CATEGORY_ID,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  productDetailApiResponse: null,
  productDetailData: [],
  productImageData: [],
  productDetailRecord: null,
  productCategoryId: null,
};

const productDetail = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_PRODUCT_DETAIL_LIST_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.productDetailData = response.responseData;
        } else {
          draft.productDetailData = [];
        }
        break;

      case GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.productDetailData = response.responseData;
        } else {
          draft.productDetailData = [];
        }
        break;

      case ADD_PRODUCT_DETAIL_RESPONSE:
        draft.productDetailApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE:
        draft.productDetailApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_RESPONSE:
        draft.productDetailApiResponse = action.payload.apiResponse;
        break;

      case DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE:
        draft.productDetailApiResponse = action.payload.apiResponse;
        break;

      case GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.productImageData = response.responseData;
        } else {
          draft.productImageData = [];
        }
        break;

      case UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE:
        draft.productDetailApiResponse = action.payload.apiResponse;
        break;

      case DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE:
        draft.productDetailApiResponse = action.payload.apiResponse;
        break;

      case SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_RESPONSE:
        draft.productDetailApiResponse = action.payload.apiResponse;
        break;

      case SET_PRODUCT_CATEGORY_ID:
        draft.productCategoryId = action.payload.id;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default productDetail;
